/**
 * @file Manages the navigation storage in local storage
 */

export type Stampcard = {
  selectedStampCardId: string;
  selectedSlotNumber: number;
  selectedStampCampaignId: string;
};

/**
 * Get the current Nav
 */
export function get(): Stampcard | null {
  const stampcard = window.localStorage.getItem('stampcard');

  if (stampcard) {
    return JSON.parse(stampcard);
  }

  return null;
}

/**
 * Set the Nav
 *
 * @param nav
 */
export function set(stampcard: Stampcard) {
  window.localStorage.setItem('stampcard', JSON.stringify(stampcard));
}

/**
 * Remove the nav
 */
export function remove() {
  window.localStorage.removeItem('stampcard');
}
